<template>
  <div class="price-content" :style="bold?'font-weight:bold':null">
    <div class="price" :class="prefix">
      <span :style="{ fontSize: `${fontSize}px` }">{{ point | getPriceInt }}</span>
      <span
        v-if="isDecimal"
        class="decimal"
        :style="{ fontSize: `${decimalFontSize}px` }"
      >{{ point | getPriceDecimal }}</span>
    </div>
  </div>
</template>

<script>
import Big from 'big.js';
//精度计算
const amount = (s, n = 100) => {
  let x = new Big(s);
  let y = x.times(n);
  return y.toFixed(2);
};
export default {
  props: {
    //前缀样式
    prefix: {
      type: String,
      default: 'RMB'
    },
    //前缀样式
    bold: {
      type: Boolean,
      default: true
    },
    //是否有小数
    isDecimal: {
      type: Boolean,
      default: true
    },
    //小数点字体大小
    fontSize: {
      type: Number,
      default: 28
    },
    //小数点字体大小
    decimalFontSize: {
      type: Number,
      default: 28
    },
    //传入以分为单位
    point: {
      type: Number,
      default: 0
    },
    filterType: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  methods: {},
  filters: {
    getPriceInt(point) {
      if (!point || point == 0) {
        return 0;
      }
      let floatPrice = amount(point, 0.01);
      floatPrice = parseInt(floatPrice);
      return floatPrice;
    },
    getPriceDecimal(point) {
      let decimal = '';
      if (!point || point <= 0) {
        return decimal;
      }
      let floatPrice = amount(point, 0.01);
      if (point < 99) {
        decimal = `${floatPrice}`.replace(/0\./g, '');
      } else {
        let intPrice = parseInt(floatPrice);
        intPrice = `${intPrice}.`;
        decimal = `${floatPrice}`.replace(new RegExp(intPrice), '');
      }
      if (decimal === '00' || decimal === '0') {
        return '';
      }
      decimal = `.${decimal}`;
      return decimal;
    }
  }
};
</script>

<style lang="scss">
.price-content {
  display: inline-block;
  vertical-align: bottom;
  /* font-weight: bold; */
  .price {
    &.RMB:before {
      content: '￥';
      font-size: 14px;
    }
    &.PLUS:before {
      content: '+';
      font-size: 14px;
    }
    &.MINUS:before {
      content: '-';
      font-size: 14px;
    }
  }
  .decimal {
    &.isLittle {
    }
  }
}
</style>
